import React, { PureComponent } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import { OccupancySelectorContent } from '@kognitiv/bf-library';
import { occupancyShape } from 'Constants/PropTypes';

/**
 * Prints a list of occupancies for each room, allowing to decrease
 * or increase the amount of rooms within the given limit
 */
class RoomList extends PureComponent {
    constructor() {
        super();
    }
    render() {
        const {
            occupancy, maxChildAge, minChildAge, maxOccupancy, minOccupancy, maxRoomsPerBooking, childrenEnabled,
            onChangeAdults, onChangeChildren, onChangeChildrenAge, onChangeRoomsQuantity, onRemoveRoom, widgetId, intl,
        } = this.props;

        const occupancyProps = {
            occupancy,
            childrenEnabled,
            minChildAge,
            maxChildAge,
            maxOccupancy,
            maxRoomsPerBooking,
            minOccupancy,
            onChangeRoomsQuantity: (numberOfRooms) => onChangeRoomsQuantity(widgetId, numberOfRooms),
            onRemoveRoom: (index) => onRemoveRoom(widgetId, index),
            onChangeAdults: (roomIndex, numberOfAdults) => onChangeAdults(widgetId, roomIndex, numberOfAdults),
            onChangeChildren: (roomIndex, numberOfChildren) => onChangeChildren(widgetId, roomIndex, numberOfChildren),
            onChangeChildrenAge: (roomIndex, childIndex, childrenAge) => onChangeChildrenAge(widgetId, roomIndex, childIndex, childrenAge),
            intl,
        };
        return (
            // i18nLabel[bf.adults]
            // i18nLabel[bf.children]
            // i18nLabel[bf.occupancy.childAgeSelectorLabel]
            // i18nLabel[bf.maxOccupancyMessage]
            // i18nLabel[bf.yearsCount]
            // i18nLabel[widgets.reservations.room.add]
            // i18nLabel[bf.roomNumber]
            // i18nLabel[bf.occupancy.dropdown.summary]
            // i18nLabel[bf.maxRoomsPerBooking]
            // i18nLabel[bf.occupancy.childAgeSelectorLabelBelowZero]
            <OccupancySelectorContent {...occupancyProps}/>
        );
    }
}

RoomList.propTypes = {
    widgetId              : PropTypes.string.isRequired,
    childrenEnabled       : PropTypes.bool.isRequired,
    maxChildAge           : PropTypes.number.isRequired,
    minChildAge           : PropTypes.number.isRequired,
    maxOccupancy          : PropTypes.number.isRequired,
    maxRoomsPerBooking    : PropTypes.number.isRequired,
    minOccupancy          : PropTypes.number.isRequired,
    occupancy             : PropTypes.arrayOf(PropTypes.shape(occupancyShape)).isRequired,
    onChangeRoomsQuantity : PropTypes.func.isRequired,
    onRemoveRoom          : PropTypes.func.isRequired,
    onChangeAdults        : PropTypes.func.isRequired,
    onChangeChildren      : PropTypes.func.isRequired,
    onChangeChildrenAge   : PropTypes.func.isRequired,
    intl                  : intlShape.isRequired,
};

export default injectIntl(RoomList);
